export const RACING_MODULE_NAME = 'racing';
export const RACING_MODULE_PATH = '/racing/';

//game Name
export const VPP_MARBLES_EURO = 'Marbles_Euro';
export const VPP_MARBLES_SAND = 'Marbles2';

export const TO_WIN = {
    name: 'TO_WIN',
    code: '1'
};
export const PLACE = {
    name: 'PLACE',
    code: '2'
};
export const SHOW = {
    name: 'SHOW',
    code: '3'
};
export const FORECAST = {
    name: 'FORECAST',
    code: '5'
};
export const TRICAST = {
    name: 'TRICAST',
    code: '6'
};

export const REVERSE_FORECAST = {
    name: 'REVERSE_FORECAST',
    code: '7'
};
export const REVERSE_TRICAST = {
    name: 'REVERSE_TRICAST',
    code: '8'
};
export const TO_WIN_EW = {
    name: 'TO_WIN_EW',
    code: '43'
};

export const FORECAST_MARBLE = {
    name: 'FORECAST_MARBLE',
    code: '5'
};
export const TRICAST_MARBLE = {
    name: 'TRICAST_MARBLE',
    code: '6'
};

export const REVERSE_FORECAST_MARBLE = {
    name: 'REVERSE_FORECAST_MARBLE',
    code: '7'
};
export const REVERSE_TRICAST_MARBLE = {
    name: 'REVERSE_TRICAST_MARBLE',
    code: '8'
};

export const BET_TYPES = [
    TO_WIN,
    PLACE,
    SHOW,
    FORECAST,
    TRICAST,
    REVERSE_FORECAST,
    REVERSE_TRICAST,
    TO_WIN_EW
];

export const RACING_MARKETS = BET_TYPES;

export const MARBLE_BET_TYPES = [
    TO_WIN,
    PLACE,
    SHOW,
    FORECAST_MARBLE,
    TRICAST_MARBLE,
    REVERSE_FORECAST_MARBLE,
    REVERSE_TRICAST_MARBLE,
    TO_WIN_EW
];
/*This will map UID to Supported markets for racing*/
export const SUPPORTED_RACING_MARKETS = {
    "VPP_Horses_Sprints": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name],
    "VPP_Horses_Flats": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name],
    "VPP_Horses_Jumps": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name],
    "VPP_MotorRacing_StockCars": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name],
    "VPP_MotorRacing_IndyCars": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name],
    "VPP_Dogs_Flats": [TO_WIN.name, PLACE.name, TO_WIN_EW.name],
    "VPP_Marbles_Sand2": [TO_WIN.name, PLACE.name, SHOW.name],
    "VPP_Marbles_Euro": [TO_WIN.name, PLACE.name, SHOW.name],
    "VPP_Marbles_Halloween": [TO_WIN.name, PLACE.name, SHOW.name],
    "VPP_Dogs_City": [TO_WIN.name, PLACE.name, TO_WIN_EW.name],
    "VPP_Horses_US": [TO_WIN.name, PLACE.name, SHOW.name, TO_WIN_EW.name]
};

export const MARBLE_MARKETS = MARBLE_BET_TYPES;




// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/constants/identifiers.js